var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kd-button',{attrs:{"icon":"","size":_vm.size,"type":_vm.type},on:{"click":_vm.handleClick}},[_c(_vm.name,_vm._b({tag:"component",attrs:{"fill":_vm.fill}},'component',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }